import React, { useState, useEffect } from "react"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Alert,
  Label,
  Input,
  Badge,
  FormGroup,
} from "reactstrap"
import { post, del } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import Loader from "common/loader"
import Select from "react-select"
import moment from "moment"
import { SEARCH_TIMESLOT, REMOVE_TIMESLOT } from "helpers/api_endpoints"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"

//meta title
document.title = "Time Slots"

const PartnersBranchTimeSlotList = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const [timeSlots, setTimeSlots] = useState([])
  const [searchTimeSlots, setSearchTimeSlots] = useState([])
  const [trigger, setTrigger] = useState(false)
  const [filters, setFilters] = useState({})
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [successMsg, setsuccessMsg] = useState("")
  const [errorMsg, seterrorMsg] = useState("")
  const [partnerBranchName, setPartnerBranchName] = useState("")
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null)
  const slotStatus = [
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
  ]
  const daysOfWeek = [
    { value: 0, label: "Sunday" },
    { value: 1, label: "Monday" },
    { value: 2, label: "Tuesday" },
    { value: 3, label: "Wednesday" },
    { value: 4, label: "Thursday" },
    { value: 5, label: "Friday" },
    { value: 6, label: "Saturday" },
  ]

  useEffect(() => {
    if (location.state) {
      if (location.state.successMsg) {
        setsuccessMsg(location.state.successMsg)
        setTimeout(() => {
          setsuccessMsg("")
          navigate(location.pathname, { replace: true, state: {} })
        }, 4000)
      }
      if (location.state.errorMsg) {
        seterrorMsg(location.state.errorMsg)
        setTimeout(() => {
          seterrorMsg("")
          navigate(location.pathname, { replace: true, state: {} })
        }, 4000)
      }
    }

    fetchTimeSlots()
  }, [page, filters, location.state, navigate, location.pathname])

  const fetchTimeSlots = () => {
    setLoading(true)
    post(SEARCH_TIMESLOT)
      .then(response => {
        const data = response.data
        setTimeSlots(data)
        setSearchTimeSlots(data)
        setTotalPages(data.pagination?.totalPages || 1)
        setPage(data.pagination?.currentPage || 1)
        setLoading(false)
      })
      .catch(error => {
        if (error?.response?.status == 400) {
          console.log(error)
        }
        setLoading(false)
      })
  }

  const removeTimeSlot = () => {
    setLoading(true)
    del(REMOVE_TIMESLOT)
      .then(response => {
        navigate("/timeslots", { state: { successMsg: "Time slot removed successfully" } });
      })
      .catch(error => {
        if (error?.response?.status == 400) {
          console.log(error)
        }
        setLoading(false)
      })
  }

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }

  const handleDaysOfWeek = days => {
    const dayOptions = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ]
    let dayNames = ""
    days.some(day => {
      dayNames += dayOptions[day] + ", "
    })
    return dayNames
  }

  const handleFilter = (type, val) => {
    const sTimeSlots = [...timeSlots]
    setSearchTimeSlots(timeSlots)
    let res = []
    if (val == undefined) return
    // console.log('d', type, val, timeSlots.length,searchTimeSlots.length)
    if (type == "name") {
      res = sTimeSlots.filter(el => {
        return el.name.indexOf(val) > -1
      })
    } else if (type == "slotDateFrom") {
      res = sTimeSlots.filter(el => {
        return el.slotDateFrom.indexOf(val) > -1
      })
    } else if (type == "slotDateTo") {
      res = sTimeSlots.filter(el => {
        return el.slotDateTo.indexOf(val) > -1
      })
    } else if (type == "daysOfWeek") {
      res = sTimeSlots.filter(el => {
        return el.daysOfWeek.indexOf(parseInt(val)) > -1
      })
    } else if (type == "slotStatus") {
      res = sTimeSlots.filter(el => {
        return el.status == val
      })
    }
    setSearchTimeSlots(res)
  }

  console.log(searchTimeSlots)

  const formatTime = t => {
    if (!t) return ""
    const m = moment(t, ["HH:mm:ss", "HH:mm", moment.ISO_8601], true)
    if (m.isValid()) return m.format("hh:mm A")
    const m2 = moment(t)
    return m2.isValid() ? m2.format("hh:mm A") : t
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Time Slots" />
          <Row>
            <Col xl={12}>
              <Card>
                <br></br>
                {successMsg ? (
                  <Alert style={{ margin: "25px" }} color="success">
                    {successMsg}
                  </Alert>
                ) : null}
                <CardTitle>
                  <Link to={`/timeslots/add`}>
                    <button
                      style={{ float: "right", marginRight: "20px" }}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="dripicons-plus"></i> &nbsp;
                      <Trans>Create Time Slot</Trans>
                    </button>
                  </Link>
                </CardTitle>
                <div style={{ margin: "25px" }}>
                  <div className="row">
                    <div className="form-group col-md-2 mt-2">
                      <Label className="form-label">
                        <Trans>Name</Trans>
                      </Label>
                      <Input
                        name="name"
                        className="form-control"
                        placeholder=""
                        type="text"
                        onChange={e => handleFilter("name", e.target.value)}
                        onKeyDown={e => handleFilter("name", e.target.value)}
                      ></Input>
                    </div>
                    <div className="form-group col-md-2 mt-2">
                      <Label className="form-label">
                        <Trans>Date from</Trans>
                      </Label>
                      <Input
                        name="slotDateFrom"
                        className="form-control"
                        placeholder=""
                        type="date"
                        onChange={e =>
                          handleFilter("slotDateFrom", e.target.value)
                        }
                      ></Input>
                    </div>
                    <div className="form-group col-md-2 mt-2">
                      <Label className="form-label">
                        <Trans>Date To</Trans>
                      </Label>
                      <Input
                        name="slotDateTo"
                        className="form-control"
                        placeholder=""
                        type="date"
                        onChange={e =>
                          handleFilter("slotDateTo", e.target.value)
                        }
                      ></Input>
                    </div>
                    <div className="form-group col-md-2 mt-2">
                      <Label className="form-label">
                        <Trans>Recurring days</Trans>
                      </Label>
                      <Select
                        name="daysOfWeek"
                        options={daysOfWeek}
                        className="form-control select2"
                        isClearable={true}
                        onChange={e => handleFilter("daysOfWeek", e?.value)}
                      />
                    </div>
                    <div className="form-group col-md-2 mt-2">
                      <Label className="form-label">
                        <Trans>Status</Trans>
                      </Label>
                      <Select
                        name="orderStatusId"
                        options={slotStatus}
                        className="form-control select2"
                        onChange={e => handleFilter("slotStatus", e.value)}
                      />
                    </div>
                  </div>
                </div>

                <CardBody>
                  {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                  <div className="table-responsive">
                    <Table className="table table-striped table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>
                            <Trans>ID</Trans>
                          </th>
                          <th>
                            <Trans>Time Slot Name</Trans>
                          </th>
                          <th>
                            <Trans>Date from</Trans>
                          </th>
                          <th>
                            <Trans>Date To</Trans>
                          </th>
                          <th>
                            <Trans>Recurring days</Trans>
                          </th>
                          <th>
                            <Trans>Status</Trans>
                          </th>
                          <th>#</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <th colSpan={9} className="text-center">
                              <Loader></Loader>
                            </th>
                          </tr>
                        ) : null}

                        {searchTimeSlots &&
                        searchTimeSlots.length === 0 &&
                        !loading ? (
                          <tr>
                            <td colSpan={9} className="text-center">
                              <Trans>No time slots found</Trans>
                            </td>
                          </tr>
                        ) : null}
                        {searchTimeSlots &&
                          searchTimeSlots.map((timeSlot, index) => (
                            <tr key={index}>
                              <td>{timeSlot.id}</td>
                              <td>
                                {timeSlot.name}
                                <Table
                                  bordered
                                  style={{
                                    marginTop: "10px",
                                    borderCollapse: "separate",
                                    borderSpacing: "0 10px",
                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                                    borderRadius: "5px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <thead style={{ backgroundColor: "#f8f9fa" }}>
                                    <tr>
                                      <th>
                                        Time From
                                      </th>
                                      <th>
                                        Time To
                                      </th>
                                      <th>
                                        Cut off time ( Starts allocating )
                                      </th>
                                      <th>
                                        Orders Count
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {timeSlot.timeSlotDet.map((slot, index) => (
                                      <tr
                                        key={index}
                                      >
                                        <td>
                                          {formatTime(slot.timeFrom)}
                                        </td>
                                        <td>
                                          {formatTime(slot.timeTo)}
                                        </td>
                                        <td>
                                          {formatTime(slot.prepareTimeTo)}
                                        </td>
                                        <td>
                                          {slot.ordersCount}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </td>
                              <td>
                                {timeSlot.slotDateFrom &&
                                  timeSlot.slotDateFrom.split("T")[0]}
                              </td>
                              <td>
                                {timeSlot.slotDateTo &&
                                  timeSlot.slotDateTo.split("T")[0]}
                              </td>
                              <td>{handleDaysOfWeek(timeSlot.daysOfWeek)}</td>
                              <td>
                                <Badge
                                  className={
                                    timeSlot.status == 0
                                      ? "bg-danger"
                                      : "bg-success"
                                  }
                                >
                                  <Trans>
                                    {timeSlot.status == 0
                                      ? "inactive"
                                      : "active"}
                                  </Trans>
                                </Badge>
                              </td>
                              <td>
                                <Link to={`/timeslots/edit/${timeSlot.id}`}>
                                  <button className="btn btn-sm btn-info">
                                    <i className="dripicons-pencil"></i> &nbsp;
                                    <Trans>Duplicate</Trans>
                                  </button>
                                </Link>{" "}
                                &nbsp;
                              </td>
                              <td>
                                <Link to={`/timeslots/remove/${timeSlot.id}`}>
                                  <button className="btn btn-sm btn-danger">
                                    <i className="dripicons-pencil"></i> &nbsp;
                                    <Trans>Remove</Trans>
                                  </button>
                                </Link>{" "}
                                &nbsp;
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                  <br></br>
                  {totalPages > 1 && (
                    <div className="text-center">
                      <button
                        className="btn btn-sm btn-dark"
                        onClick={handlePrevPage}
                        disabled={page === 1}
                      >
                        <Trans>Previous</Trans>
                      </button>
                      &nbsp;
                      <button
                        className="btn btn-sm btn-dark"
                        onClick={handleNextPage}
                        disabled={page === totalPages}
                      >
                        <Trans>Next</Trans>
                      </button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PartnersBranchTimeSlotList
